import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './recorded-meeting.reducer';

export const RecordedMeetingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const recordedMeetingEntity = useAppSelector(state => state.recordedMeeting.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="recordedMeetingDetailsHeading">
          <Translate contentKey="fivePlusApp.recordedMeeting.detail.title">RecordedMeeting</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{recordedMeetingEntity.id}</dd>
          <dt>
            <span id="recordedMeetingId">
              <Translate contentKey="fivePlusApp.recordedMeeting.recordedMeetingId">Recorded Meeting Id</Translate>
            </span>
          </dt>
          <dd>{recordedMeetingEntity.recordedMeetingId}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.recordedMeeting.meeting">Meeting</Translate>
          </dt>
          <dd>{recordedMeetingEntity.meeting ? recordedMeetingEntity.meeting.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/recorded-meeting" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/recorded-meeting/${recordedMeetingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RecordedMeetingDetail;
